import React from "react";
import SectionHead from "../ui/SectionHead";
import Reveal from "../ui/Reveal";
import Corners from "../ui/Corners";
import { USE_CASES } from "../../data/site";
import { ArrowRight } from "../ui/Icons";
import { scrollToSection } from "../../lib/scroll";
import "./UseCases.css";

export default function UseCases() {
  return (
    <section id="usecases" className="section">
      <div className="container">
        <SectionHead
          eyebrow="Industry applications"
          title="Built for the environments where seeing matters."
          lead="The same platform, tuned per industry: different models, zones and rules, one operational picture."
        />
        <div className="uc">
          {USE_CASES.map((u, i) => (
            <Reveal
              key={u.id}
              as="article"
              className={`uc__tile uc__tile--${u.size}`}
              delay={i * 0.06}
            >
              <img src={u.image} alt="" loading="lazy" decoding="async" />
              <div className="uc__shade" />
              <Corners className="uc__corners" />
              <span className="uc__label mono">
                <span className="dot" />
                {u.label}
              </span>
              <div className="uc__body">
                <h3 className="uc__title">{u.title}</h3>
                <p className="uc__desc">{u.description}</p>
                <div className="chips uc__chips">
                  {u.tags.map((t) => (
                    <span key={t} className="chip">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal as="article" className="uc__tile uc__tile--w uc__cta" delay={0.3}>
            <div className="uc__cta-inner">
              <span className="eyebrow eyebrow--plain">Something else?</span>
              <h3 className="h3">Your environment, your model.</h3>
              <p className="uc__desc uc__desc--always">
                Logistics yards, ports, retail floors, energy sites. If a camera can see it,
                we can build a detector for it.
              </p>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => scrollToSection("contact")}
              >
                Talk to us <ArrowRight className="i" />
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
